import client from '@services/TokenInterceptorServices';

export const getGcspMyDashboardData = async (YEAR, ACCOUNT_ID, EMAIL, DATE) => {
  // Email Required *
  const URL = '/gcsp/dashboard/currentmetrics';
  const PAYLOAD = {
    email: EMAIL,
    year: YEAR,
    date: DATE,
    account_id: ACCOUNT_ID,
  };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const getGcspYearlyMetrics = async (YEAR, SERVICE_LINE, ACCOUNT_ID, EMAIL, DATE) => {
  // Email Required *
  const URL = '/gcsp/dashboard/yearlymetrics';
  const PAYLOAD = {
    email: EMAIL,
    year: YEAR,
    date: DATE,
    account_id: ACCOUNT_ID,
    service: SERVICE_LINE?.toLowerCase(),
  };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data[0];
};

export const getGCSProllingOpportunities = async (
  GCSP_ID,
  ACCOUNT_ID,
  MONTH,
  YEAR,
  TYPE,
  START_DATE,
  END_DATE,
  CURRENT_MONTH,
  EMAIL,
  IS_READONLY,
) => {
  const URL =
    IS_READONLY || IS_READONLY === null
      ? '/gcspreadonly/forecast/opportunities'
      : '/gcsp/forecast/opportunities';
  const PAYLOAD = {
    gcspid: GCSP_ID,
    account_id: ACCOUNT_ID,
    start_date: START_DATE,
    end_date: END_DATE,
    type: TYPE,
    month: MONTH,
    year: YEAR,
    email: EMAIL,
    submitted_month: CURRENT_MONTH,
  };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const subHeaderGCSPPastQtrDetails = async (QUARTER, YEAR, EMAIL) => {
  // Email Required *
  const URL = '/user/quarter';
  const PAYLOAD = { quarter: QUARTER, year: YEAR, email: EMAIL };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const subHeaderGCSPPastMonthDetails = async (QUARTER, MONTH, YEAR, EMAIL) => {
  // Email Required *
  const URL = '/user/quarter';
  const PAYLOAD = { quarter: QUARTER, year: YEAR, month: MONTH, email: EMAIL };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const getGCSPPastOpportunitiesMonthly = async (
  EMAIL,
  ACCOUNT_ID,
  MONTH,
  YEAR,
  TYPE,
  QUARTER,
) => {
  const URL = '/gcsp/past/opportunities';
  const PAYLOAD = {
    email: EMAIL,
    account_id: ACCOUNT_ID,
    type: TYPE,
    year: YEAR,
    month: MONTH,
    quarter: QUARTER,
  };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const getGCSPPastOpportunitiesQuaterly = async (
  EMAIL,
  ACCOUNT_ID,
  MONTH,
  YEAR,
  TYPE,
  QUARTER,
) => {
  const URL = '/gcsp/past/opportunities';
  const PAYLOAD = {
    email: EMAIL,
    account_id: ACCOUNT_ID,
    type: TYPE,
    year: YEAR,
    month: 'null',
    quarter: QUARTER,
  };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const submitGCSPopportunity = async REQ_BODY => {
  try {
    const URL = '/gcsp/submit/forecast';
    const PAYLOAD = REQ_BODY;
    const response = await client.post(URL, PAYLOAD);

    if (response?.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

export const submitGgcspAggregateJudgeData = async (
  ACCOUNT_ID,
  EMAIL,
  MONTH,
  YEAR,
  QUARTER,
  REQ_BODY,
) => {
  const URL = '/gcsp/submit/judge';
  const RESPONSE = await client.post(URL, {
    account_id: ACCOUNT_ID,
    email: EMAIL,
    month: MONTH,
    year: YEAR,
    quarter: QUARTER,
    judge: REQ_BODY,
  });
  return RESPONSE.status === 200;
};
